import Action from './baseActions';

export enum UiActionTypes {
  SELECT_HEADER = 'ui/select_header',
  SELECT_HEADER_TITLE = 'ui/select_header_title',
  RESET_HEADER = 'ui/reset_header',
  SELECT_LEFT_PANEL_BACKGROUND = 'ui/select_left_panel_background',
  RESET_LEFT_PANEL_BACKGROUND = 'ui/reset_left_panel_background',
  SET_IS_DARK_MODE = 'ui/set_is_dark_mode',
  SET_HIDE_INTERCOM = 'ui/hide_intercom',
  SET_SHOW_SUBSCRIPTION_DIALOG = 'ui/set_show_subscription_dialog',
  // Report Trigger Dialog
  TOGGLE_TRIGGER_DIALOG = 'ui/toggle_trigger_dialog',
  // Connection Dialog
  TOGGLE_CONNECTION_DIALOG = 'ui/toggle_connection_dialog',
  // Integration Dialog
  TOGGLE_INTEGRATION_DIALOG = 'ui/toggle_integration_dialog',
  // Create Saved Block Dialog
  TOGGLE_SAVED_BLOCK_DIALOG = 'ui/toggle_saved_block_dialog',
}

export interface ISelectHeaderAction extends Action {
  type: UiActionTypes.SELECT_HEADER;
  payload: {
    header: string;
    properties: { [key: string]: string | boolean };
  }
}

export interface ISelectHeaderTitleAction extends Action {
  type: UiActionTypes.SELECT_HEADER_TITLE;
  payload: { title: string; elementId: string };
}

export interface IResetHeaderAction extends Action {
  type: UiActionTypes.RESET_HEADER;
}

export interface ISelectLeftPanelBackgroundAction extends Action {
  type: UiActionTypes.SELECT_LEFT_PANEL_BACKGROUND;
  payload: {
    background: string;
  }
}

export interface ISetIsDarkModeAction extends Action {
  type: UiActionTypes.SET_IS_DARK_MODE;
  payload: boolean;
}

export interface ISetHideIntercom extends Action {
  type: UiActionTypes.SET_HIDE_INTERCOM;
  payload: boolean;
}

export interface ISetShowSubscriptionDialog extends Action {
  type: UiActionTypes.SET_SHOW_SUBSCRIPTION_DIALOG;
  payload: boolean;
}

export interface IResetLeftPanelBackgroundAction extends Action {
  type: UiActionTypes.RESET_LEFT_PANEL_BACKGROUND;
}

export interface ToggleTriggerDialogAction extends Action {
  type: UiActionTypes.TOGGLE_TRIGGER_DIALOG;
  payload: {
    show: boolean;
    type: string | null;
    data?: any;
  }
}

export interface ToggleConnectionDialog extends Action {
  type: UiActionTypes.TOGGLE_CONNECTION_DIALOG
  payload: {
    show: boolean;
    type: string | null;
  }
}

export interface ToggleIntegrationDialog extends Action {
  type: UiActionTypes.TOGGLE_INTEGRATION_DIALOG;
  payload: {
    show: boolean;
    type: string | null;
  }
}

export interface ToggleSavedBlockDialog extends Action {
  type: UiActionTypes.TOGGLE_SAVED_BLOCK_DIALOG;
  payload: {
    show: boolean;
    contentId: string | null;
  }
}

// functions

export function selectHeader(header: string, properties?: { [key: string]: string | boolean }): ISelectHeaderAction {
  return {
    type: UiActionTypes.SELECT_HEADER,
    payload: {
      header,
      properties: properties || {}
    }
  }
}

export function selectHeaderTitle(title: string, elementId: string): ISelectHeaderTitleAction {
  return {
    type: UiActionTypes.SELECT_HEADER_TITLE,
    payload: {
      title,
      elementId
    }
  }
}

export function resetHeader(): IResetHeaderAction {
  return {
    type: UiActionTypes.RESET_HEADER
  }
}

export function selectLeftPanelBackground(background: string): ISelectLeftPanelBackgroundAction {
  return {
    type: UiActionTypes.SELECT_LEFT_PANEL_BACKGROUND,
    payload: {
      background
    }
  }
}

export function setIsDarkMode(isDarkMode: boolean): ISetIsDarkModeAction {
  return {
    type: UiActionTypes.SET_IS_DARK_MODE,
    payload: isDarkMode
  }
}

export function setHideIntercom(hide: boolean): ISetHideIntercom {
  return {
    type: UiActionTypes.SET_HIDE_INTERCOM,
    payload: hide
  }
}

export function setShowSubscriptionDialog(show: boolean): ISetShowSubscriptionDialog {
  return {
    type: UiActionTypes.SET_SHOW_SUBSCRIPTION_DIALOG,
    payload: show
  }
}

export function resetLeftPanelBackground(): IResetLeftPanelBackgroundAction {
  return {
    type: UiActionTypes.RESET_LEFT_PANEL_BACKGROUND
  }
}

export function toggleTriggerDialog(
  show: boolean,
  type?: string | null,
  data?: any,
): ToggleTriggerDialogAction {
  return {
    type: UiActionTypes.TOGGLE_TRIGGER_DIALOG,
    payload: {
      show,
      type: type || null,
      data: data || null,
    }
  }
}

export function toggleConnectionDialog(show: boolean, type: string | null = null): ToggleConnectionDialog {
  return {
    type: UiActionTypes.TOGGLE_CONNECTION_DIALOG,
    payload: {
      show,
      type: type || null,
    }
  }
}

export function toggleIntegrationDialog(show: boolean, type: string | null = null): ToggleIntegrationDialog {
  return {
    type: UiActionTypes.TOGGLE_INTEGRATION_DIALOG,
    payload: {
      show,
      type: type || null,
    }
  }
}

export function toggleSavedBlockDialog(
  show: boolean,
  contentId: string | null = null
): ToggleSavedBlockDialog {
  return {
    type: UiActionTypes.TOGGLE_SAVED_BLOCK_DIALOG,
    payload: {
      show,
      contentId,
    }
  }
}

export type UiAction =
  ISelectHeaderAction |
  ISelectHeaderTitleAction |
  IResetHeaderAction |
  ISelectLeftPanelBackgroundAction |
  IResetLeftPanelBackgroundAction |
  ISetIsDarkModeAction |
  ISetHideIntercom |
  ISetShowSubscriptionDialog |
  ToggleTriggerDialogAction |
  ToggleConnectionDialog |
  ToggleIntegrationDialog |
  ToggleSavedBlockDialog;
